<template>
  <!-- 2018-03-02 23:59:00 -->
  <!-- "Y-m-d H:i:s" -->
  <aside :class="formCountDown ? 'boxCountDown mb-4' : 'boxCountDown mb-4 d-flex flex-row justify-content-center'">
    <section v-if="!formCountDown" class="d-flex flex-row w-100 w-sm-55 w-md-50 w-lg-35 w-xl-30">
      <div class="countDown w-50">
        <section class="block-digit d-flex flex-row justify-content-center">
          <p class="w-25 border">{{ days | two_digits }}</p>
          <p class="w-25 border">{{ hours | two_digits }}</p>
          <p class="w-25 border">{{ minutes | two_digits }}</p>
          <p class="w-25 border">{{ seconds | two_digits }}</p>
        </section>
        <section class="block-text d-flex flex-row justify-content-center">
          <p class="w-25 border">Jrs</p>
          <p class="w-25 border">Hrs</p>
          <p class="w-25 border">Min</p>
          <p class="w-25 border">Sec</p>
        </section>
      </div>
      <div class="countDown w-50">
        <section class="block-digit ">
          <p class="border">SMS Pers.</p>
        </section>
        <section class="block-text">
          <p class="border">{{ getNombreSmsPersonnalise }}</p>
        </section>
      </div>
      <div class="countDown w-50">
        <section class="block-digit ">
          <p class="border text-nowrap">SMS Non-Pers.</p>
        </section>
        <section class="block-text">
          <p class="border">{{ getNombreSmsNonPersonnalise }}</p>
        </section>
      </div>
    </section>
    <div v-if="formCountDown" class="form-floating mb-4">
      <textarea class="form-control overflow-hidden" id="nombre_jours_restants" disabled>{{ days | two_digits }} Jours {{ hours | two_digits }} Heures {{ minutes | two_digits }} Minutes {{ seconds | two_digits }} Secondes</textarea>
      <label for="nombre_jours_restants">Nombre de jours restants</label>
    </div>
  </aside>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "CountDown",
  props: {
    formCountDown: {
      type: Boolean
    }
  },
  data () {
    return {
      date: '',
      now: Math.trunc((new Date()).getTime() / 1000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([
        'setValidSubscription',
        'setNombreSmsPersonnalise',
        'setNombreSmsNonPersonnalise',
    ]),
    ...mapActions([
        'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([
      'getUtilisateurId',
      'getNombreSmsPersonnalise',
      'getNombreSmsNonPersonnalise',
    ]),
    dateInMilliseconds() {
      return Math.trunc(Date.parse(this.date) / 1000)
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    }
  },
  watch: {
    minutes(minutes) {
      if(this.days <= 0 && this.hours <= 0 && minutes <= 0 && this.seconds <=0)
        this.setValidSubscription(false)
      else this.setValidSubscription(true)
    }
  },
  beforeCreate() {},
  created() {
    window.setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);
    },1000);
    this.axiosGetOneData({table: "abonnements_utilisateur", table_id: this.getUtilisateurId})
        .then((data) => {
          if(data.status === "echec"){
            let currentDateTime = new Date();
            this.date = currentDateTime.getFullYear() + '-' +('0' + (currentDateTime.getMonth()+1)).slice(-2)+ '-' +
                ('0' + currentDateTime.getDate()).slice(-2) + ' '+currentDateTime.getHours()+ ':'+('0' +
                    (currentDateTime.getMinutes())).slice(-2)+ ':'+currentDateTime.getSeconds();
            this.setNombreSmsPersonnalise(0)
            this.setNombreSmsNonPersonnalise(0)
          }else {
            this.date = data.data.date_temps_fin_abonnement
            this.setNombreSmsPersonnalise(data.data.nombre_sms_personnalise)
            this.setNombreSmsNonPersonnalise(data.data.nombre_sms_non_personnalise)
          }
        })
        .catch()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
aside.boxCountDown{
  section{
    div.countDown{
      & > section{
        text-align: center;
        & > p{
          margin-bottom: 0;
        }
      }
      & > section.block-digit{
        & > p{
          color: var(--color-second);
          background: var(--color-first);
          font-size: larger;
          font-weight: bold;
          text-align: center;
        }
      }
      & > section.block-text{
        & > p{
          background: var(--color-second);
          color: var(--color-first);
          font-size: larger;
          font-weight: bold;
          text-align: center;
        }
      }
    }
  }
  div.form-floating{
    & > textarea.form-control{
      border-radius: .8rem;
      height: 3rem;
      padding-top: 1.25rem;
    }
    & > label{
      padding-top: .7rem;
      color: var(--color-first);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/CountDown.vue